module.exports = __webpack_public_path__ + "static/media/PingFang-SC-Light.59717686.svg";